var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "module-subnav-container" },
    [
      _c(
        "div",
        { staticClass: "field is-grouped is-hidden-widescreen mobile-nav" },
        [
          _vm._l(_vm.visibleMenuItems, function (item, index) {
            return _c(
              "p",
              { key: `mobile-${index}`, staticClass: "control" },
              [
                item.route
                  ? _c(
                      "router-link",
                      {
                        staticClass:
                          "button tooltip is-tooltip-bottom is-small",
                        class: { "is-disabled": item.disabled },
                        attrs: {
                          to: item.route,
                          "active-class": "is-active",
                          exact: item.exact !== false,
                          title: item.label,
                          "data-tooltip": item.label,
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.handleItemClick(item, $event)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "icon",
                            class: item.badgeClass,
                            attrs: { "data-badge": item.badge },
                          },
                          [
                            _c("span", { staticClass: "mso mso-20px" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    item.icon || _vm.getDefaultIcon(item.label)
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _c(
                      "a",
                      {
                        staticClass:
                          "button tooltip is-tooltip-bottom is-small",
                        class: { "is-disabled": item.disabled },
                        attrs: {
                          title: item.label,
                          "data-tooltip": item.label,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleItemClick(item, $event)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "icon",
                            class: item.badgeClass,
                            attrs: { "data-badge": item.badge },
                          },
                          [
                            _c("span", { staticClass: "mso mso-20px" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    item.icon || _vm.getDefaultIcon(item.label)
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
              ],
              1
            )
          }),
          _vm.hasMoreItems
            ? _c("p", { staticClass: "control" }, [_vm._m(0)])
            : _vm._e(),
        ],
        2
      ),
      _c(
        "ul",
        {
          staticClass:
            "menu-list horizontal is-hidden-mobile is-hidden-tablet-only is-hidden-desktop-only",
        },
        [
          _vm._l(_vm.visibleMenuItems, function (item, index) {
            return _c(
              "li",
              { key: index },
              [
                item.route
                  ? _c(
                      "router-link",
                      {
                        class: { "is-disabled": item.disabled },
                        attrs: {
                          to: item.route,
                          "active-class": "is-active",
                          exact: item.exact !== false,
                        },
                        nativeOn: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.handleItemClick(item, $event)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "is-flex is-align-items-center is-justify-content-space-between",
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "is-flex is-align-items-center" },
                              [
                                _c("span", { staticClass: "icon" }, [
                                  _c("span", { staticClass: "mso mso-20px" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.icon ||
                                            _vm.getDefaultIcon(item.label)
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass: "ml-1",
                                    class: item.badgeClass,
                                    attrs: { "data-badge": item.badge },
                                  },
                                  [_vm._v(_vm._s(item.label))]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _c(
                      "a",
                      {
                        class: { "is-disabled": item.disabled },
                        on: {
                          click: function ($event) {
                            return _vm.handleItemClick(item, $event)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "is-flex is-align-items-center is-justify-content-space-between",
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "is-flex is-align-items-center" },
                              [
                                _c("span", { staticClass: "icon" }, [
                                  _c(
                                    "span",
                                    { staticClass: "mso mso-20px mr-2" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.icon ||
                                              _vm.getDefaultIcon(item.label)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c(
                                  "span",
                                  {
                                    class: item.badgeClass,
                                    attrs: { "data-badge": item.badge },
                                  },
                                  [_vm._v(_vm._s(item.label))]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                _vm._t("menu-item-actions", null, {
                  item: item,
                  handleAction: _vm.handleCustomAction,
                }),
              ],
              2
            )
          }),
          _vm.hasMoreItems
            ? _c("li", { staticClass: "is-flex" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "button is-small px-4 is-align-self-center moreMenuButton",
                    class: `has-hero-button-text-${_vm.$theme.name}`,
                    staticStyle: { border: "none" },
                    attrs: { name: "moreMenuButton" },
                  },
                  [_vm._m(1)]
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm.hasMoreItems
        ? _c(
            "tippy",
            {
              ref: "tippyMoreMenu",
              attrs: {
                to: "moreMenuButton",
                trigger: "click",
                arrow: "",
                interactive: true,
                theme: `${_vm.$theme.name}`,
                "max-width": 500,
              },
            },
            [
              _c("div", { staticClass: "menu more-menu" }, [
                _c(
                  "ul",
                  { staticClass: "menu-list" },
                  _vm._l(_vm.visibleMoreItems, function (item, index) {
                    return _c(
                      "li",
                      { key: index },
                      [
                        item.route
                          ? _c(
                              "router-link",
                              {
                                class: { "is-disabled": item.disabled },
                                attrs: {
                                  to: item.route,
                                  "active-class": "is-active",
                                  exact: item.exact !== false,
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.handleMoreItemClick(item)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "is-flex is-align-items-center",
                                  },
                                  [
                                    _c("span", { staticClass: "icon pr-3" }, [
                                      _c(
                                        "span",
                                        { staticClass: "mso mso-20px" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.icon ||
                                                _vm.getDefaultIcon(item.label)
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "span",
                                      {
                                        class: item.badgeClass,
                                        attrs: { "data-badge": item.badge },
                                      },
                                      [_vm._v(_vm._s(item.label))]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "is-flex is-align-items-center",
                                class: { "is-disabled": item.disabled },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleMoreItemClick(item)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "icon pr-3" }, [
                                  _c("span", { staticClass: "mso mso-20px" }, [
                                    _vm._v(
                                      _vm._s(
                                        item.icon ||
                                          _vm.getDefaultIcon(item.label)
                                      )
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "span",
                                  {
                                    class: item.badgeClass,
                                    attrs: { "data-badge": item.badge },
                                  },
                                  [_vm._v(_vm._s(item.label))]
                                ),
                              ]
                            ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm.hasMoreItems
        ? _c(
            "tippy",
            {
              ref: "tippyMobileMoreMenu",
              attrs: {
                to: "mobileMoreMenuButton",
                trigger: "click",
                arrow: "",
                interactive: true,
                "max-width": 500,
              },
            },
            [
              _c("div", { staticClass: "menu more-menu" }, [
                _c(
                  "ul",
                  { staticClass: "menu-list" },
                  _vm._l(_vm.visibleMoreItems, function (item, index) {
                    return _c(
                      "li",
                      { key: index },
                      [
                        item.route
                          ? _c(
                              "router-link",
                              {
                                class: { "is-disabled": item.disabled },
                                attrs: {
                                  to: item.route,
                                  "active-class": "is-active",
                                  exact: item.exact !== false,
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.handleMobileMoreItemClick(item)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "is-flex is-align-items-center",
                                  },
                                  [
                                    item.icon
                                      ? _c(
                                          "span",
                                          { staticClass: "icon pr-3" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "mso mso-20px mr-2",
                                              },
                                              [_vm._v(_vm._s(item.icon))]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      {
                                        class: item.badgeClass,
                                        attrs: { "data-badge": item.badge },
                                      },
                                      [_vm._v(_vm._s(item.label))]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "is-flex is-align-items-center",
                                class: { "is-disabled": item.disabled },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleMobileMoreItemClick(item)
                                  },
                                },
                              },
                              [
                                item.icon
                                  ? _c("span", { staticClass: "icon pr-3" }, [
                                      _c(
                                        "span",
                                        { staticClass: "mso mso-20px mr-2" },
                                        [_vm._v(_vm._s(item.icon))]
                                      ),
                                    ])
                                  : _vm._e(),
                                _c(
                                  "span",
                                  {
                                    class: item.badgeClass,
                                    attrs: { "data-badge": item.badge },
                                  },
                                  [_vm._v(_vm._s(item.label))]
                                ),
                              ]
                            ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "button is-small",
        attrs: { name: "mobileMoreMenuButton" },
      },
      [
        _c("span", { staticClass: "icon" }, [
          _c("span", { staticClass: "mso mso-20px" }, [_vm._v("more_vert")]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "mso mso-20px" }, [_vm._v("more_vert")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }